import { FrameTimer } from "./FrameTimer";

export class FrameTimerPool {
    public static pool: Object = {};
    public static paused: boolean = false;

    public static add(key: string, item: any): void {
        FrameTimerPool.pool[key] = item;
    }

    public static remove(key: string): void {
        delete FrameTimerPool.pool[key];
    }

    public static pause(force: boolean = false): void {
        if (FrameTimerPool.paused && !force) {
            return;
        }
        for (let key in FrameTimerPool.pool) {
            if (FrameTimerPool.pool[key] instanceof FrameTimer) {
                FrameTimerPool.pool[key].pause();
            }
        }
        FrameTimerPool.paused = true;
    }

    public static unpause(force: boolean = false): void {
        if (!FrameTimerPool.paused && !force) {
            return;
        }
        for (let key in FrameTimerPool.pool) {
            if (FrameTimerPool.pool[key] instanceof FrameTimer) {
                FrameTimerPool.pool[key].unpause();
            }
        }
        FrameTimerPool.paused = false;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/FrameTimerPool.ts
 **/